<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <v-form ref="update_data" @submit.prevent="update_data">
          <div class="grid_header">
            <div></div>
            <div class="text-center ma-4">
              <div class="text_font">ฟอร์มส่งคืน/เปลี่ยนสินค้า</div>
              <div>บริษัท ฟาร์มาแคร์ พลัส จำกัด</div>
            </div>
            <div class="ma-4">
              <div class="grid_flex justify-end">
                <div class="mr-2">เลขที่เอกสาร :</div>
                <div>{{ data_set.doc_no }}</div>
              </div>
              <div class="grid_flex justify-end">
                <div class="mr-2">TF :</div>
                <div>{{ data_set.tf_no }}</div>
              </div>
            </div>
          </div>
<!--          <div class="grid_list_input">-->
<!--            <div class="grid_input">-->
<!--              <div class="ma-4">-->
<!--                <div class="pa-2 pt-4">{{ data_set.supplier_name }}</div>-->
<!--&lt;!&ndash;                <v-autocomplete clearable color="#86bc3a" :items="supplier_list" item-text="name" item-value="id" @input="get_product_list(save_data.supplier_id)" v-model="save_data.supplier_id" prepend-inner-icon="mdi-domain" label="บริษัทซัพพลายเออร์" hide-details="auto" outlined></v-autocomplete>&ndash;&gt;-->
<!--              </div>-->
<!--              <div class="ma-4">-->
<!--                <v-text-field color="#86bc3a" label="ผู้แทน" prepend-inner-icon="mdi-account" :rules="[v => !!v || 'กรุณากรอกผู้แทน']" v-model="data_set.representative" hide-details="auto" outlined></v-text-field>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="grid_list_input">
            <div class="grid_input">
              <div class="ma-4">
                <div class="pa-2 pt-4 text-center">{{ data_set.supplier_name }}</div>
                <!--                <v-autocomplete clearable color="#86bc3a" :items="supplier_list" item-text="name" item-value="id" @input="get_product_list(save_data.supplier_id)" v-model="save_data.supplier_id" prepend-inner-icon="mdi-domain" label="บริษัทซัพพลายเออร์" hide-details="auto" outlined></v-autocomplete>-->
              </div>
              <div class="ma-4">
                <v-text-field color="#86bc3a" label="ผู้แทน" prepend-inner-icon="mdi-account" :rules="[v => !!v || 'กรุณากรอกผู้แทน']" v-model="data_set.representative" hide-details="auto" outlined></v-text-field>
              </div>
            </div>
            <div class="grid_input">
              <div class="ma-4">
                <v-menu ref="menu_return" v-model="menu_return" :close-on-content-click="false" :return-value.sync="data_list.return_date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" v-model="data_list.return_date" label="วันที่แจ้งคืนสินค้า (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่แจ้งคืนสินค้า']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH_return(returnEN)" :max="startDate" v-model="returnEN" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="returnDate(data_list.return_date)">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_return = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
<!--              <div class="ma-4 mobile_input">-->
<!--                <v-menu ref="menu_delivery" v-model="menu_delivery" :close-on-content-click="false" :return-value.sync="data_list.send_date" transition="scale-transition" offset-y min-width="auto">-->
<!--                  <template v-slot:activator="{ on, attrs }">-->
<!--                    <v-text-field color="#86bc3a" v-model="data_list.send_date" label="วันที่ส่งสินค้า (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่ส่งสินค้า']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>-->
<!--                  </template>-->
<!--                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(deliveryEN)" v-model="deliveryEN" no-title scrollable>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-btn text color="primary" @click="deliveryDate(data_list.send_date)">-->
<!--                      ตกลง-->
<!--                    </v-btn>-->
<!--                    <v-btn text color="primary" @click="menu_delivery = false">-->
<!--                      ยกเลิก-->
<!--                    </v-btn>-->
<!--                  </v-date-picker>-->
<!--                </v-menu>-->
<!--              </div>-->
              <div class="ma-4 mobile_margin">
                <v-autocomplete clearable color="#86bc3a" :items="user_list" item-text="name" item-value="id" v-model="data_set.return_user_id" :rules="[v => !!v || 'กรุณากรอกผู้แจ้งเตือน']" prepend-inner-icon="mdi-account-alert" label="ผู้แจ้งเตือน" hide-details="auto" outlined></v-autocomplete>
              </div>
            </div>
          </div>
          <div class="grid_checkbox ma-4">
            <div class="ma-2 mt-4">แจ้งโดย</div>
            <v-radio-group v-model="data_set.notified_by" mandatory>
              <div class="grid_checkbox_list">
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>Line.</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>โทร</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>ต่อหน้า</div>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="grid_checkbox ma-4">
            <div class="ma-2 mt-4">สาเหตุที่ส่งคืน</div>
            <v-radio-group v-model="data_set.cause_return" mandatory>
              <div class="grid_checkbox_list">
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>ของมาผิด</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>ของไม่ได้สั่ง</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>ชำรุด</div>
                </div>
                <div class="d-flex align-center mb-3">
                  <div class="mr-3">
                    <v-radio color="#86bc3a" :value="4"></v-radio>
                  </div>
                  <div>สินค้าหมดอายุ</div>
                </div>
                <div class="d-flex align-center mt-4">
                  <div>
                    <v-radio color="#86bc3a" :value="3"></v-radio>
                  </div>
                  <div v-if="data_set.cause_return !== 3">อื่นๆ</div>
                  <div class="mt-n3 mr-4" v-if="data_set.cause_return === 3">
                    <v-text-field color="#86bc3a" label="รายละเอียด" prepend-inner-icon="" v-model="data_set.cause_text" hide-details="auto" required outlined></v-text-field>
                  </div>
                  <!-- มี INPUT ด้วยย -->
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="grid_checkbox ma-4">
            <div class="ma-2 mt-4 red--text">วิธิการแก้ไข</div>
            <v-radio-group v-model="data_set.issue_select" mandatory>
              <div class="grid_checkbox_issue">
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>ทำใบ C/N.</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>คืนเป็นสินค้าเดิม</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>
                    <div v-if="data_set.issue_select !== 2">คืนเป็นสินค้าใหม่</div>
                    <div class="mt-n3 mr-4" v-if="data_set.issue_select === 2">
                      <v-text-field color="#86bc3a" label="รายละเอียด" prepend-inner-icon="" v-model="data_set.note_issue" hide-details="auto" required outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="3"></v-radio>
                  </div>
                  <div>คืนไปเลยเพราะส่งผิด</div>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="d-flex align-center ma-4">
            <v-col cols="2">หมายเหตุ</v-col>
            <v-col cols="4">
              <v-text-field style="width: 400px" color="#86bc3a" label="หมายเหตุ" v-model="data_set.general_remark"
                hide-details="auto" outlined></v-text-field>
            </v-col>
          </div>
          <div class="pa-2">
            <v-card-title>
              รายการสินค้าส่งคืน
            </v-card-title>
            <div class="grid_full pa-4">
              <div style="display: flex !important;">
                <v-autocomplete clearable color="#86bc3a" :items="product_list" item-text="product_name" item-value="warehouse_return_id" @input="addProduct" v-model="data_list.id" prepend-inner-icon="mdi-flask-plus-outline" label="สินค้า" hide-details="auto" outlined/>
              </div>
            </div>
            <v-data-table :headers="headers" :items="doc_lists" key="index" :footer-props="footer_Props" :items-per-page="per_page" mobile-breakpoint="0">
              <template v-slot:item="dataDetails">
                <tr>
                  <td>{{ dataDetails.index + 1 }}</td>
                  <td>{{ dataDetails.item.product_name }}</td>
                  <td>{{ dataDetails.item.lot_no }}</td>
                  <td>
                    <v-text-field color="#86bc3a" type="number" @keypress="isOnlyNumber($event)" label="จำนวน" :rules="[v => !!v || 'กรุณากรอกจำนวน']" hide-details="auto" min="0" v-model="dataDetails.item.qty" outlined></v-text-field>
                  </td>
                  <td>{{ dataDetails.item.unit_name }}</td>
                  <td>
                    <div class="ma-4">
                      <v-text-field color="#86bc3a" label="หมายเหตุ" v-model="dataDetails.item.reason" prepend-inner-icon="" hide-details="auto" outlined></v-text-field>
                    </div>
                  </td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDelete(dataDetails.item.loop_id, dataDetails.item.return_product_list_id, dataDetails.item.warehouse_return_id)" class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div class="pt-3 pb-5 text-center grid_btn">
            <v-btn x-large class="grad-success-bg white--text mr-4 ml-4" type="submit" style="font-size: 18px" :disabled="disabled">บันทึกข้อมูล</v-btn>
          </div>
        </v-form>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {formatNumber, minDate, onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Government_receipt_edit",
  data() {
    return {
      overlay: false,
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      menu_delivery: false,
      menu_return: false,
      disabled: false,
      deliveryEN: '',
      returnEN: '',
      startDate: this.min_date(),
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      per_page: -1,
      headers: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'รหัสล็อต',
          value: 'lot_no',
          fixed: true,
          width: '160px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '125px',
        },
      ],
      data_set: [],
      user_list: [],
      product_list: [],
      doc_lists: [],
      data_list: {
        id: '',
        send_date: '',
        return_date: '',
      },
      selected_arr: [],
      loop_id: 0
    }
  },
  methods: {
    async deliveryDate(value) {
      this.$refs.menu_delivery.save(value)
      this.menu_delivery = false
    },
    async returnDate(value) {
      this.$refs.menu_return.save(value)
      this.menu_return = false
    },
    min_date: function() {
      return minDate()
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    diffDateThai(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])+ 543
        return day+'-'+month+'-'+year
      }
      else {
        value = ''
        return  value
      }
    },
    diffDateTH(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])+ 543
        const date_th = day+'-'+month+'-'+year
        return this.data_list.send_date = date_th
      }
      else {
        return this.data_list.send_date = ''
      }
    },
    diffDateTH_return(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])+ 543
        const date_th = day+'-'+month+'-'+year
        return this.data_list.return_date = date_th
      }
      else {
        return this.data_list.return_date = ''
      }
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/returnproductdocs/edit', {
        return_doc_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.data_set = res.data.doc
          this.data_list.send_date = this.diffDateThai(this.data_set.send_date)
          this.data_list.return_date = this.diffDateThai(this.data_set.return_date)
          this.deliveryEN = res.data.doc.send_date
          this.returnEN = res.data.doc.return_date
          this.user_list = res.data.users
          res.data.doc_lists.forEach((data) => {
            const id = this.loop_id += 1;
            this.doc_lists.push({
              loop_id: id,
              return_product_list_id: data.return_product_list_id,
              return_product_id: data.return_product_id,
              product_id: data.product_id,
              product_name: data.product_name,
              warehouse_return_id: data.warehouse_return_id,
              lot_no: data.lot_no,
              qty: data.qty,
              unit_id: data.unit_id,
              unit_name: data.unit_name,
              reason: data.reason,
            })
          })
          const warehouse_id = this.doc_lists.map((detail) => {
            return detail.warehouse_return_id
          })
          this.selected_arr = warehouse_id
          this.get_product_list()
        }
      })
    },
    get_product_list() {
      this.product_list = []
      HTTP.post('/returnproductdocs/edit', {
        return_doc_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          res.data.supplier_product.forEach((data) => {
            let inc = this.selected_arr.includes(data.warehouse_return_id)
            if (inc === false) {
              this.product_list.push({
                cost: data.cost,
                created_at: data.created_at,
                date_expired: data.date_expired,
                discount_percent: data.discount_percent,
                discount_price: data.discount_price,
                discount_unit: data.discount_unit,
                exchange_status: data.exchange_status,
                import_product_id: data.import_product_id,
                is_delete: data.is_delete,
                lot_no: data.lot_no,
                price: data.price,
                product_code: data.product_code,
                product_id: data.product_id,
                product_name: data.product_name,
                quantity: data.quantity,
                status: data.status,
                supplier_id: data.supplier_id,
                supplier_name: data.supplier_name,
                unit_id: data.unit_id,
                unit_name: data.unit_name,
                warehouse_return_id: data.warehouse_return_id,
              })
            }
          })
        }
      })
    },
    async addProduct() {
      let value = this.product_list.filter((result) => {
        return result.warehouse_return_id === this.data_list.id
      })
      value.forEach((data) => {
        const id = this.loop_id += 1;
        this.doc_lists.push({
          loop_id: id,
          return_product_list_id: null,
          return_product_id: null,
          product_id: data.product_id,
          product_name: data.product_name,
          warehouse_return_id: data.warehouse_return_id,
          lot_no: data.lot_no,
          qty: data.quantity,
          unit_id: data.unit_id,
          unit_name: data.unit_name,
          reason: '',
        })
      })
      this.selected_arr.push(this.data_list.id)
      this.get_product_list()
      await this.$nextTick(() => {
        this.data_list.id = null;
        this.alert_success = true;
        setTimeout(() => this.alert_success = false, 2000);
      })
    },
    getDelete(loop_id, return_product_list_id, warehouse_return_id) {
      const find_product = this.doc_lists.filter(data => data.warehouse_return_id === warehouse_return_id)
      const map_product = find_product.map(data => data.warehouse_return_id)
      const pop_id = map_product.pop()
      const index = this.selected_arr.indexOf(pop_id);
      if (index > -1) {
        this.selected_arr.splice(index, 1);
      }
      this.doc_lists = this.doc_lists.filter(data => data.warehouse_return_id !== warehouse_return_id)
      this.get_product_list()
      this.data_list.id = null
      this.alert_danger = true
      setTimeout(() => this.alert_danger = false, 2000);
      // if (return_product_list_id !== null) {
      //   HTTP.post('/returnproductdocs/deletelist', {
      //     return_product_list_id: return_product_list_id
      //   }).then((res) => {
      //     if (res.data.success === true) {
      //       this.alert_danger = true;
      //       setTimeout(() => this.alert_danger = false, 2000);
      //       this.doc_lists = this.doc_lists.filter(data => data.loop_id !== loop_id)
      //     }
      //   })
      // }
      // else {
      //   this.alert_danger = true;
      //   setTimeout(() => this.alert_danger = false, 2000);
      //   this.doc_lists = this.doc_lists.filter(data => data.loop_id !== loop_id)
      // }

    },
    update_data() {
      if (this.$refs.update_data.validate()) {
        if (this.doc_lists.length > 0) {
          Swal.fire({
            title: 'คุณต้องการแก้ไขข้อมูลหรือไม่ !',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              this.overlay = true
              this.disabled = true
              HTTP.post('/returnproductdocs/update', {
                return_product_doc_id: this.$route.params.id,
                doc_no: this.data_set.doc_no,
                tf_no: this.data_set.tf_no,
                supplier_id: this.data_set.supplier_id,
                representative: this.data_set.representative,
                send_date: this.deliveryEN,
                return_date: this.returnEN,
                return_user_id: this.data_set.return_user_id,
                notified_by: this.data_set.notified_by,
                cause_return: this.data_set.cause_return,
                cause_text: this.data_set.cause_text,
                issue_select: this.data_set.issue_select,
                note_issue: this.data_set.note_issue,
                general_remark: this.data_set.general_remark,
                doc_lists: this.doc_lists
              }).then((res) => {
                if (res.data.success === true) {
                  this.overlay = false
                  Swal.fire({
                    title: 'แก้ไขข้อมูลสำเร็จ !',
                    icon: 'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then(() => {
                    this.$router.push('/stock/document/returnproductreceipt')
                  })
                }
                else {
                  Swal.fire({
                    title: 'แก้ไขข้อมูลไม่สำเร็จ !',
                    text: res.data.message,
                    icon: 'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then(() => {
                    this.overlay = false
                    this.disabled = false
                  })
                }
              })
            }
          })
        }
        else {
          Swal.fire({
            title: 'พบข้อผิดพลาด !',
            text: 'รายการสินค้าห้ามว่าง !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else {
        Swal.fire({
          title: 'พบข้อผิดพลาด !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.text_font {
  font-size: 26px;
}
.grid_flex {
  display: flex;
}
.grid_header {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_list_input {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_input {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_checkbox {
  display: grid;
  grid-template-columns: 15% 85%;
}
.grid_checkbox_issue {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_checkbox_list {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.mobile_margin {
  margin: 0;
}
@media only screen and (max-width: 1180px) {
  .grid_list_input {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_input {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .grid_checkbox_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_checkbox_issue {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 700px) {
  .grid_header {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_list_input {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_input {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_checkbox {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_checkbox_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_checkbox_issue {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_btn {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .mobile_input {
    margin-top: -15px !important;
    margin-bottom: -10px !important;
  }
  .mobile_margin {
    margin-top: -17px !important;
  }
}
</style>
